export default "__VITE_ASSET__CC6q7U8h__"